module.exports = __webpack_public_path__ + "img/9788937833366.83aa96c8.jpg";